<template class="bg-[#fafbfb]">
  <section class="text-white pt-16 lg:pt-24 pb-[150px] lg:pb-[220px]"
           :style="{ background: `linear-gradient(rgba(7, 30, 66, 0.55), rgba(7, 30, 66, 0.55)), url('/images/${eventId}/hero.webp') no-repeat center`, backgroundSize: 'cover' }"
  >
    <div class="container px-4 mx-auto">
      <div class="flex flex-col justify-center items-center">
        <img class="w-[82px] lg:w-[180px]" src="/images/all/logos/tracx-logo-white.svg" alt="tracx logo">
        <h1 class="mt-8 text-white text-center lg:mt-12 text-4xl lg:text-6xl">Beneva Cheerscreen</h1>
        <p class="text-xl mb-4 lg:mb-8 text-center lg:text-2xl">
          Your Beneva Marathon Cheer Photos
        </p>
        <img class="mt-6 lg:mt-12 w-[150px] lg:w-[180px]" :src="'/images/' + eventId + '/logos/beneva-mississauga.svg'" alt="Beneva Mississauga logo">
      </div>
    </div>
  </section>

  <div class="container px-[40px] mx-auto shadow-lg max-w-[910px] bg-white -mt-[100px] md:rounded pt-20">
    <h2 class="mb-12 text-center text-4xl">Find your photo's</h2>
    <form class="w-full flex justify-center mb-20" @submit.prevent="search" id="search">
      <div class="flex flex-col sm:flex-row justify-center sm:items-end w-full gap-6 max-w-[500px]">
        <div class="flex flex-col">
          <label class="mb-3" for="startNumber">Enter your bib number:</label>
          <input class="rounded border px-3 py-2 flex-grow-1" v-model="userInputStartNumber" type="text"
                 id="startNumber"
                 placeholder="1234" required>
        </div>
        <button class="btn mr-auto sm:mr-0" type="submit">Search</button>
      </div>
    </form>

    <div class="py-14 px-8 bg-gray-100 w-[calc(100%+80px)] -ml-[40px]" v-if="submissions.length > 0 || startNumber">
      <div v-if="submissions.length > 0">
        <h3 class="text-center mb-10">Your Beneva Marathon Cheer Photos</h3>

        <div class="grid grid-cols-1 gap-8 lg:grid-cols-26">
          <div class="flex flex-col justify-center items-center" v-for="(submission, index) in submissions" :key="index">
            <div class="rounded-lg bg-white aspect-square w-full max-w-[500px] relative radiant">
              <img class="rounded-lg w-full h-full object-cover absolute top-0 right-0 z-0" :src="submission.image ?? '/images/all/cheerscreen-photo-backdrop.png'" alt="">
              <img class="absolute right-[20px] top-[28px] z-20 w-[125px]" :src="'/images/' + eventId + '/logos/beneva.svg'" alt="">
              <img class="absolute left-[20px] top-[20px] z-20 w-[125px]" :src="'/images/' + eventId + '/logos/beneva-mississauga.svg'" alt="">
              <p class="absolute text-4xl font-semibold w-[450px] z-20 break-words text-white"
                 :class="submission.image ? 'left-[20px] bottom-[66px]' : 'left-[50%] bottom-[50%] translate-x-[-50%] translate-y-[50%] text-center'"
              >{{ submission.message }}</p>
              <p class="absolute left-[20px] bottom-[20px] text-3xl z-20 font-semibold mt-2 text-white">- {{ submission.name_cheerer }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="startNumber" class="py-10">
        <h3 class="text-center">
          Unfortunately, there was no photo submitted for you this year. But that doesn't take anything away from your amazing performance. Congratulations!
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import {getSubmissionByStartNumber} from "@/firebase";

export default {
  name: 'photosPage',
  data() {
    return {
      eventId: 1900,
      submissions: [],
      startNumber: null,
      userInputStartNumber: '',
    };
  },
  mounted() {
    if (this.$route.query.start_number) {
      this.startNumber = this.$route.query.start_number;
      this.userInputStartNumber = this.startNumber;
      this.readSubmissions();
    }
  },
  methods: {
    async readSubmissions() {
      if (this.startNumber) {
        this.submissions = await getSubmissionByStartNumber(this.startNumber, this.eventId.toString());
      }
    },
    async search() {
      this.startNumber = this.userInputStartNumber;
      await this.readSubmissions();
    },
    downloadImage(url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = 'cheer-photo.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

<style scoped lang="scss">
</style>
